'use client';

import { motion } from 'motion/react';
import { JSX, PropsWithChildren } from 'react';

import { Button, ShadCNButtonProps } from '@shadCN/ui/button';

interface Props extends PropsWithChildren, ShadCNButtonProps {}

const MotionButton: React.FC<Props> = ({ children, ...props }) => {
  const MotionComponent = motion.create(Button, { forwardMotionProps: true });

  return (
    <MotionComponent
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      {...props}>
      {children}
    </MotionComponent>
  );
};

export default MotionButton;
